import React from 'react';
import firebase from '../../helper/firebase';
import _ from 'lodash';

import { Link } from 'react-router-dom';

import Head from '../../components/Head';
import JobCardHeader from '../../components/JobCardHeader';
import JobCardContent from '../../components/JobCardContent';
import UnpublishedJob from '../../components/UnpublishedJob';
import EmptyState from '../../components/EmptyState';
import LoggedOutCard from '../../components/LoggedOutCard';
import UnauthorizedText from '../../components/UnauthorizedText';
import SkeletonCard from '../../components/SkeletonCard';
import { Title } from '../../helper/consts';

import Fade from 'material-ui/transitions/Fade';

import {
	Button,
	Card,
	CardActions,
	CircularProgress,
	Divider
} from 'material-ui';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class BatchInvites extends React.Component {
	constructor() {
		super();

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			archiveLoading: true,
			snackStatus: false,
			snackMessage: '',
			getVolume: 3,
			getVolumeIncrement: 1,
			getVolumeArchives: 3,
			getVolumeIncrementArchives: 1
		};
	}

	componentDidMount() {
		let references = [
			{
				uid: '',
				stateName: 'myJobs',
				dbName: 'myJobs',
				dispatchName: 'JobsState/GET_MYJOBS',
				getJobs: true
			}
		];
		this.props.actions.getMyListener(references);
	}

	componentWillUnmount() {
		firebase
			.database()
			.ref(`myOffers/${this.props.uid}`)
			.off();
	}

	renderJobs = () => {
		const { myJobs, jobs } = this.props;
		let html = [];
		if (_.isEmpty(myJobs)) {
			let card = (
				<EmptyState
					key="no jobs"
					subject={'No Offers'}
					message={'Start sharing an offer.'}
					btnDestination={'/'}
					btnMsg={'Home'}
				/>
			);
			html.push(card);
			return html;
		} else {
			Object.keys(myJobs)
				.filter(jid => !myJobs[jid].archived)
				.filter(jid => !!jobs[jid])
				.filter(jid => jobs[jid].status !== 'hired')
				.map(jid => {
					let job = jobs[jid];
					job.oid = myJobs[jid].oid;
					return job;
				})
				.forEach(job => {
					let card = (
						<Fade key={job.jid} in={true}>
							<Card className="card">
								<JobCardHeader job={job} />
								<Divider light />
								{job.status !== 'published' ? null : (
									<JobCardContent job={job} wrap={true} />
								)}
								{job.status !== 'published' ? (
									<UnpublishedJob status={job.status} />
								) : null}
								<CardActions className="cardActions">
									<Link
										className="cardActionsBtn"
										to={`/BatchInvite/${job.oid}`}
									>
										<Button raised>Batch Invite</Button>
									</Link>
								</CardActions>
							</Card>
						</Fade>
					);
					html.push(card);
				});
			if (html.length === 0) {
				let card = (
					<EmptyState
						key="no unarchived offers"
						subject={'No Unarchived Offers'}
						message={'Start sharing offers.'}
						btnDestination={'/'}
						btnMsg={'Home'}
					/>
				);
				html.push(card);
				return html;
			}
			return html;
		}
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Batch Invites | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}
					{this.props.loggedIn &&
						this.props.myJobsLoading &&
						this.props.admin && (
							<SkeletonCard header={true} content={true} actions={true} />
						)}
					{this.props.loggedIn &&
						!this.props.myJobsLoading &&
						this.props.admin &&
						this.renderJobs()}
					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}
					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
				</div>
			</React.Fragment>
		);
	}
}
// {!this.state.loading && !this.state.authLoading && this.state.loggedIn?<ViewMoreFeedBtn key={'load more'} onClickfunction={()=>{this.loadMore('unarchived')}} text={'Load More'} />:null}



// WEBPACK FOOTER //
// ./src/pages/BatchInvites/BatchInvites.js